// extracted by mini-css-extract-plugin
export default {"toast":"Toast_toast__DKvnV","success":"Toast_success__sdL7m","error":"Toast_error__7-0nq"};